module.exports = __webpack_public_path__ + "img/education.80663c64.jpg";